<template>
  <v-chip outlined small>
    <time class="d-flex align-center">
      <v-icon small class="pe-1 grey--text">mdi-timer-outline</v-icon>
      <p class="mb-0 grey--text text--darken-1">{{ humanizedDueDate }}</p>
    </time>
  </v-chip>
</template>

<script>
import { utils } from 'frontend-js-shared'

export default {
  name: 'FindingDueDate',

  props: {
    dueDate: String,
  },
  computed: {
    humanizedDueDate() {
      if (!this.dueDate) return this.$t('common.no_due_date_label')
      return utils.dates.formatDate(this.dueDate, 'MMM D, YYYY, h:mm A')
    },
  },
}
</script>
